import React from 'react';
import { Modal, Button, message } from 'antd';
import DataService from '../../lib/DataService';

const PHONE_REG = /^1\d{10}$/;

/*
 * 班级管理页添加老师：和学校管理员的"老师管理"一样，直接填写姓名和手机号。
 *   - 手机号不存在：直接创建老师并加入本班
 *   - 老师已在本校：直接加入本班
 *   - 老师在其他学校：确认后先加入本校，再加入本班
 *   - 手机号已存在但姓名与已登记的不一致：弹出提醒，用户确认是同一位老师后才添加，已登记的姓名不会被修改
 *
 * props:
 *   showModal, classId
 *   callBack(teacher): 添加成功后回调，teacher 为 { id, full_name, avatar_url, mobile_phone, is_admin }
 *   onHideModal(): 关闭弹窗
 */
export default class AddClassTeacherModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = this._initialState();

    this.handleName = this.handleName.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.submit = this.submit.bind(this);
    this.confirm = this.confirm.bind(this);
    this.backToForm = this.backToForm.bind(this);
    this.close = this.close.bind(this);
  }

  _initialState() {
    return {
      view: 'form',        // form | confirm
      fullName: '',
      mobilePhone: '',
      lookup: null,        // 预检结果
      submitting: false,
    };
  }

  componentWillReceiveProps(newProps) {
    // 每次重新打开都清空上一次填写的内容
    if (newProps.showModal && !this.props.showModal) {
      this.setState(this._initialState());
    }
  }

  handleName(e) {
    this.setState({fullName: e.target.value});
  }

  handlePhone(e) {
    this.setState({mobilePhone: e.target.value.replace(/\D/g, '').slice(0, 11)});
  }

  close() {
    if (this.state.submitting) {
      return;
    }
    this.props.onHideModal();
  }

  backToForm() {
    this.setState({view: 'form', lookup: null});
  }

  submit() {
    if (this.state.submitting) {
      return;
    }

    let name = this.state.fullName.trim();
    let phone = this.state.mobilePhone.trim();

    if (name === '') {
      message.error('请填写老师姓名');
      return;
    }
    if (!PHONE_REG.test(phone)) {
      message.error('请输入正确的11位手机号');
      return;
    }

    this.setState({submitting: true});
    DataService.lookupClassTeacher(this.props.classId, phone, name).then(res => {
      let registered = (res.teacher && res.teacher.full_name) || '';

      if (res.status == 'in_class') {
        this.setState({submitting: false});
        message.info(`该手机号的老师${registered ? '（' + registered + '）' : ''}已经在本班了`);
      } else if (res.status == 'not_found') {
        this.join(phone, name);
      } else if (res.status == 'in_school' && res.name_matched) {
        this.join(phone, name);
      } else {
        // 其他学校的老师，或姓名与已登记的不一致：需要用户确认
        this.setState({view: 'confirm', lookup: res, submitting: false});
      }
    }, () => {
      this.setState({submitting: false});
      message.error('查询失败，请稍后重试');
    });
  }

  confirm() {
    if (this.state.submitting) {
      return;
    }
    this.setState({submitting: true});
    this.join(this.state.mobilePhone.trim(), this.state.fullName.trim());
  }

  join(phone, name) {
    DataService.addTeacherToClass(this.props.classId, phone, name).then(res => {
      this.setState({submitting: false});
      if (res.status == 'created') {
        message.success('已创建老师并加入本班');
      } else if (res.status == 'joined_school') {
        message.success('该老师已加入本校并加入本班');
      } else if (res.status == 'already_in_class') {
        message.info('该老师已在本班');
      } else {
        message.success('添加成功!');
      }
      this.props.callBack(res.teacher);
      this.props.onHideModal();
    }, (error) => {
      this.setState({submitting: false});
      let errors = error && error.errorMessage && error.errorMessage.errors;
      let code = errors && errors[0] && errors[0].code;
      if (code == 110) {
        message.error('没有权限添加老师');
      } else if (code == 22) {
        message.error('请填写老师姓名');
      } else if (code == 21) {
        message.error('请输入正确的11位手机号');
      } else {
        message.error('添加失败，请稍后重试');
      }
    });
  }

  renderForm() {
    return (
      <div className="modal-teacher-info">
        <div className="modal-input-wrapper big-cell">
          <span className="modal-label"><span className="red-point">*</span>姓名</span>
          <input className="modal-input" type="text" value={this.state.fullName} onChange={this.handleName} placeholder="请输入老师姓名" />
        </div>
        <div className="modal-input-wrapper big-cell">
          <span className="modal-label"><span className="red-point">*</span>手机号</span>
          <input className="modal-input" type="text" value={this.state.mobilePhone} onChange={this.handlePhone} placeholder="请输入11位手机号" />
        </div>
        <div className="class-teacher-tips">
          老师如果已在系统中（包括其他学校），会直接使用已有的老师信息，并加入本校和本班。
        </div>
      </div>
    );
  }

  renderConfirm() {
    let lookup = this.state.lookup || {};
    let teacher = lookup.teacher || {};
    let registered = teacher.full_name || '未登记姓名';
    let name = this.state.fullName.trim();

    return (
      <div className="modal-teacher-info class-teacher-confirm">
        {!lookup.name_matched && <div className="warning-box">
          <div className="warning-title">姓名与系统里的不一致</div>
          <div>该手机号（{teacher.mobile_phone}）已登记为「<b>{registered}</b>」，你填写的是「<b>{name}</b>」。</div>
          <div>添加后将沿用系统里已登记的姓名，不会修改老师的信息。如果是手机号填错了，请返回修改。</div>
        </div>}
        {lookup.status == 'other_school' && <div className="info-box">
          该老师目前不在本校，确认后将先把老师加入本校，再加入本班。
        </div>}
      </div>
    );
  }

  render() {
    let isConfirm = this.state.view == 'confirm';
    let footer = isConfirm ? [
      <Button key="back" size="large" className="footer-btn" disabled={this.state.submitting} onClick={this.backToForm}>返回修改</Button>,
      <Button key="ok" type="primary" size="large" className="footer-btn" loading={this.state.submitting} onClick={this.confirm}>
        {this.state.lookup && !this.state.lookup.name_matched ? '是同一位老师，确认添加' : '确认添加'}
      </Button>,
    ] : [
      <Button key="submit" type="primary" size="large" className="footer-btn" loading={this.state.submitting} onClick={this.submit}>添加老师</Button>,
    ];

    return (
      <Modal
        className="school-admin-add-teacher-modal class-teacher-modal"
        visible={this.props.showModal}
        title={isConfirm ? '请确认' : '添加老师'}
        onCancel={this.close}
        maskClosable={false}
        footer={footer}
      >
        {isConfirm ? this.renderConfirm() : this.renderForm()}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/AddClassTeacherModal.jsx